
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import fails$1 from './fails.js';

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = fails$1;

var arrayBufferNonExtensible = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

export { arrayBufferNonExtensible as default };
//# sourceMappingURL=array-buffer-non-extensible.js.map
